module.exports = __webpack_public_path__ + "static/media/share_screen_camera.b2406f0b.svg";